/** Centralized pricing config (mirror of backend/config/pricing.py). */
export const PRICING = {
  monthly: { amount_usd: 290, period: "month" },
  annual: { amount_usd: 1990, period: "year" },
  savings_percent: 43,
  annual_monthly_equiv: 166,
  currency: "USD",
  currency_symbol: "$",
};
